import { createSlice } from "@reduxjs/toolkit";

// What the student did to each community this session: { [communityId]: "JOINED" | "PENDING" | "NONE" }.
// Post cards keep their own copy of the join state, and the feeds hold posts in local state, so without this
// a community's other posts keep saying "Join" after the student joined it until the page is refreshed.
const communityJoinSlice = createSlice({
  name: "communityJoin",
  initialState: {},
  reducers: {
    setCommunityJoinStatus: (state, action) => {
      const { communityId, status } = action.payload;
      if (communityId !== undefined && communityId !== null) state[String(communityId)] = status;
    },
  },
});

export const { setCommunityJoinStatus } = communityJoinSlice.actions;
export default communityJoinSlice.reducer;
